import {createFileRoute} from '@tanstack/react-router';
import SportPortal from '../../../../sports/SportPortal.tsx';
import {SPORT_AREAS} from '../../../../sports/sportAreas.ts';

export const Route = createFileRoute('/_app/esports/leagues/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <SportPortal sport={SPORT_AREAS.esports} section="leagues"/>
}
